import AppContext from "PFApp/app_context";
import React, { useContext } from "react";

import EngagementsControls from "./parts/engagements/engagements_controls";
import EngagementsTab from "./parts/engagements/engagements_tab";
import PlannerControls from "./parts/planner/planner_controls";
import { PlannerTab } from "./parts/planner/planner_tab";
import RolesControls from "./parts/roles/roles_controls";
import RolesTab from "./parts/roles/roles_tab";
import css from "./workflow_page.module.scss";

const WorkflowPage = () => {
  const {
    store: {
      pages: {
        workflowPage: { tab }
      }
    }
  } = useContext(AppContext);

  const TabComponent = {
    engagements: EngagementsTab,
    roles: RolesTab,
    planner: PlannerTab
  }[tab];

  const ControlsComponent = {
    engagements: EngagementsControls,
    roles: RolesControls,
    planner: PlannerControls
  }[tab];

  return (
    <div>
      <div className={css.header}>
        <ControlsComponent />
      </div>
      <TabComponent />
    </div>
  );
};

export default WorkflowPage;
